module.exports = __webpack_public_path__ + "img/70.cdcf7afe.jpg";